import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function ProfiloPage() {
  const { user, setUser } = useAuth();
  const [form, setForm] = useState({ nome: "", cognome: "", email: "" });
  const [passwordCorrente, setPasswordCorrente] = useState("");
  const [savingDati, setSavingDati] = useState(false);
  const [pw, setPw] = useState({ password_attuale: "", nuova_password: "", conferma_password: "" });
  const [savingPw, setSavingPw] = useState(false);

  useEffect(() => {
    if (user) setForm({ nome: user.nome, cognome: user.cognome, email: user.email });
  }, [user]);

  const emailCambiata = !!user && form.email.trim().toLowerCase() !== user.email;

  const salvaDati = async (e) => {
    e.preventDefault();
    setSavingDati(true);
    try {
      const res = await api.put("/auth/profilo", {
        nome: form.nome,
        cognome: form.cognome,
        email: form.email,
        password_corrente: emailCambiata ? passwordCorrente : undefined,
      });
      setUser(res.data);
      setPasswordCorrente("");
      toast.success("Dati aggiornati correttamente");
    } catch (err) {
      toast.error(formatApiError(err, "Aggiornamento non riuscito"));
    } finally {
      setSavingDati(false);
    }
  };

  const salvaPassword = async (e) => {
    e.preventDefault();
    if (pw.nuova_password !== pw.conferma_password) {
      toast.error("Le password non coincidono");
      return;
    }
    setSavingPw(true);
    try {
      await api.put("/auth/password", pw);
      setPw({ password_attuale: "", nuova_password: "", conferma_password: "" });
      toast.success("Password aggiornata correttamente");
    } catch (err) {
      toast.error(formatApiError(err, "Aggiornamento non riuscito"));
    } finally {
      setSavingPw(false);
    }
  };

  return (
    <div className="mx-auto max-w-2xl px-4 py-12 sm:px-6" data-testid="profilo-page">
      <h1 className="section-title">Il mio profilo</h1>

      <div className="card-elegant mt-8" data-testid="profilo-dati-card">
        <h2 className="font-heading text-lg font-semibold text-bordeaux-dark">Dati personali</h2>
        <form onSubmit={salvaDati} noValidate className="mt-4 space-y-4" data-testid="profilo-form">
          <div className="grid gap-4 sm:grid-cols-2">
            <div>
              <label className="label-elegant" htmlFor="profilo-nome">Nome</label>
              <input id="profilo-nome" data-testid="profilo-nome-input" className="input-elegant" required
                value={form.nome} onChange={(e) => setForm({ ...form, nome: e.target.value })} />
            </div>
            <div>
              <label className="label-elegant" htmlFor="profilo-cognome">Cognome</label>
              <input id="profilo-cognome" data-testid="profilo-cognome-input" className="input-elegant" required
                value={form.cognome} onChange={(e) => setForm({ ...form, cognome: e.target.value })} />
            </div>
          </div>
          <div>
            <label className="label-elegant" htmlFor="profilo-email">Email</label>
            <input id="profilo-email" type="email" data-testid="profilo-email-input" className="input-elegant" required
              value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
          </div>
          {emailCambiata && (
            <div>
              <label className="label-elegant" htmlFor="profilo-password-corrente">Password attuale (richiesta per cambiare email)</label>
              <input id="profilo-password-corrente" type="password" data-testid="profilo-password-corrente-input" className="input-elegant" required
                value={passwordCorrente} onChange={(e) => setPasswordCorrente(e.target.value)} />
            </div>
          )}
          <button type="submit" disabled={savingDati} data-testid="profilo-save-button" className="btn-bordeaux">
            {savingDati ? "SALVATAGGIO..." : "SALVA MODIFICHE"}
          </button>
        </form>
        <dl className="mt-6 divide-y divide-border border-t border-border">
          {[
            ["Codice Fiscale", user?.codice_fiscale],
            ["Iscritto dal", user?.created_at ? new Date(user.created_at).toLocaleDateString("it-IT") : "-"],
          ].map(([k, v]) => (
            <div key={k} className="flex flex-wrap justify-between gap-2 py-3 text-sm">
              <dt className="text-muted-foreground">{k}</dt>
              <dd className="font-medium text-foreground" data-testid={`profilo-${k.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>{v}</dd>
            </div>
          ))}
        </dl>
        <p className="mt-2 text-xs text-muted-foreground">Il Codice Fiscale non è modificabile: identifica la tua posizione associativa.</p>
      </div>

      <div className="card-elegant mt-8" data-testid="profilo-password-card">
        <h2 className="font-heading text-lg font-semibold text-bordeaux-dark">Cambio password</h2>
        <form onSubmit={salvaPassword} noValidate className="mt-4 space-y-4" data-testid="password-form">
          <div>
            <label className="label-elegant" htmlFor="password-attuale">Password attuale</label>
            <input id="password-attuale" type="password" data-testid="password-attuale-input" className="input-elegant" required
              value={pw.password_attuale} onChange={(e) => setPw({ ...pw, password_attuale: e.target.value })} />
          </div>
          <div className="grid gap-4 sm:grid-cols-2">
            <div>
              <label className="label-elegant" htmlFor="nuova-password">Nuova password</label>
              <input id="nuova-password" type="password" data-testid="nuova-password-input" className="input-elegant" required
                value={pw.nuova_password} onChange={(e) => setPw({ ...pw, nuova_password: e.target.value })} />
            </div>
            <div>
              <label className="label-elegant" htmlFor="conferma-nuova-password">Conferma nuova password</label>
              <input id="conferma-nuova-password" type="password" data-testid="conferma-nuova-password-input" className="input-elegant" required
                value={pw.conferma_password} onChange={(e) => setPw({ ...pw, conferma_password: e.target.value })} />
            </div>
          </div>
          <button type="submit" disabled={savingPw} data-testid="cambio-password-button" className="btn-bordeaux">
            {savingPw ? "SALVATAGGIO..." : "CAMBIA PASSWORD"}
          </button>
        </form>
      </div>

      <p className="mt-5 rounded-lg bg-muted px-4 py-3 text-xs leading-relaxed text-muted-foreground">
        I tuoi dati personali, incluso il Codice Fiscale, sono visibili solamente a te e agli operatori ENPALSBOX autorizzati. Non vengono mai mostrati pubblicamente.
      </p>
    </div>
  );
}
